/*
 * Copyright (c) 2024. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import { Stack, Typography } from '@mui/material';
import type { SalesforceObject } from '@poweralpha/common';
import type { ReactNode } from 'react';
import { type ToastOptions, toast } from '../../paToast';
import SalesforceLinkIcon from './SalesforceLinkIcon';
import './toast.css';

interface SalesforceToastContent {
  title: string;
  body?: string;
}

export const salesforceToast = (
  content: string | ReactNode | SalesforceToastContent,
  id: string,
  object: SalesforceObject,
  opts?: ToastOptions,
  actionLabel?: string,
) => {
  let renderedContent: ReactNode;
  if (typeof content === 'string') {
    renderedContent = (
      <Typography
        sx={{
          fontSize: 14,
        }}
      >
        {content}
      </Typography>
    );
  } else if (typeof content === 'object' && content !== null && 'title' in content) {
    renderedContent = (
      <Stack
        spacing={0.25}
        sx={{
          minWidth: 0,
        }}
      >
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          {content.title}
        </Typography>
        {content.body ? (
          <Typography
            sx={{
              fontSize: 13,
            }}
          >
            {content.body}
          </Typography>
        ) : null}
      </Stack>
    );
  } else {
    renderedContent = content;
  }

  toast(
    <Stack
      direction="row"
      spacing={1.25}
      sx={{
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Stack
        sx={{
          flex: 1,
          minWidth: 0,
        }}
      >
        {renderedContent}
      </Stack>
      <SalesforceLinkIcon id={id} object={object} button label={actionLabel ?? 'Open'} />
    </Stack>,
    { ...opts, type: opts?.type ?? 'info', className: 'salesforce-toast' },
  );
};
